export const checkVerified = (consultation, attachment) => {
    var _a;
    if (!attachment.attachment_requirement_id) {
        return null;
    }
    const attachmentRequirement = (_a = consultation === null || consultation === void 0 ? void 0 : consultation.attachments) === null || _a === void 0 ? void 0 : _a.find((el) => el.type === 'attachment_requirement' && el.id === attachment.attachment_requirement_id);
    if (!attachmentRequirement) {
        return null;
    }
    return attachmentRequirement.verified;
};
